export const markerEntityName = 'marker'

export const markerDependencyManipulationMap = {
  category: 'category',
  unit: 'unit',
  createNorm: 'createNorm',
  updateNorm: 'updateNorm'
}
